<article
  class="payment-status"
  [class.payment-status--approved]="phase === 'approved'"
  [class.payment-status--warning]="phase === 'pending_confirmation' || phase === 'expired'"
  [class.payment-status--error]="phase === 'declined' || phase === 'voided' || phase === 'error'"
  role="status"
  aria-live="polite">
  <div class="payment-status__icon" aria-hidden="true">
    <i class="fas"
       [ngClass]="{
        'fa-circle-check': phase === 'approved',
        'fa-clock': phase === 'pending_confirmation' || phase === 'checking_pending',
        'fa-triangle-exclamation': phase === 'declined' || phase === 'voided' || phase === 'expired' || phase === 'error',
        'fa-credit-card': phase !== 'approved' && phase !== 'pending_confirmation' && phase !== 'declined' && phase !== 'voided' && phase !== 'expired' && phase !== 'error' && phase !== 'checking_pending'
       }"></i>
  </div>
  <div class="payment-status__body">
    <h3 class="payment-status__title">{{ messageKey | translate }}</h3>
    <p class="payment-status__detail" *ngIf="snapshot?.status?.message">{{ snapshot?.status?.message }}</p>
    <p class="payment-status__detail" *ngIf="snapshot?.message">{{ (snapshot?.message || '') | translate }}</p>
    <p class="payment-status__reference" *ngIf="snapshot?.status?.reference">
      {{ 'payments.reference' | translate }}: {{ snapshot?.status?.reference }}
    </p>
  </div>
</article>
